<template>
	<el-dialog 
		:lang="$i18n.locale" 
		:title="'选择在库订单箱'" 
		:visible.sync="dialogVisible" 
		:close-on-click-modal="false" 
		width="800px"
		:append-to-body="true"
		@close="handleCancel"
	>
		<div class="search-section" style="margin: 0 0 20px 0;vertical-align: top;">
			<el-input 
				v-model="searchText" 
				placeholder="搜索订单号或箱号，回车键可批量搜索" 
				type="textarea"
				@keyup.enter="handleSearch"
				style="width: 250px; margin-right: 10px;font-size: 12px;"
			>
			</el-input>
			<el-button style="vertical-align: top;" type="primary" icon="el-icon-search" size="small" @click="handleSearch">搜索</el-button>
			<el-button style="vertical-align: top;" icon="el-icon-refresh" size="small"  @click="handleReset">重置</el-button>
			<el-button style="vertical-align: top;" @click="handleSelectAll" size="small">全选</el-button>	
			<el-button style="vertical-align: top;" @click="handleClearSelection" size="small">清空选择</el-button>
		</div>
		<el-tree
			:data="orderTreeData"
			:loading="loading"
			show-checkbox
			node-key="id"
			ref="tree"
			:props="defaultProps"
			@check-change="handleCheckChange"
		>
			<template slot-scope="{ node, data }">
				<div class="tree-node-content" @click.stop>
					<div v-if="data.type === 'order'" class="node-main-info">
						<label class="order-type-label" v-if="data.orderType">{{ data.orderType }}</label>
						<span
							v-if="data.clientOperationTypeText"
							:class="['client-operation-tag', data.clientOperationTypeText === 'COU' ? 'client-operation-cou' : 'client-operation-cargo']"
						>
							{{ data.clientOperationTypeText }}
						</span>
						<span class="node-colon">:</span>
						<span class="node-label-text">{{ data.label }}</span>
						<span class="cartonCount" v-if="getNodeCartonCount(data) > 0">（{{ getNodeCartonCount(data) }}）</span>
					</div>
					<div v-else class="carton-node-info">
						<span class="node-label-text">{{ data.label }}</span>
					</div>
					<el-input 
								v-if="data.type === 'order' && !data.isAirCouOrder" 
								size="small"
								v-model="data.rangeInput" 
								placeholder="箱序号范围勾选，如1-2,3,5-10" 
								class="range-input"
								@keyup.enter.native="handleRangeSelect(data)"
								@click.stop
							></el-input>
				</div>
			</template>
		</el-tree>
		<div class="stats-info" style="margin: 20px 0; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
			<span>已选择订单数量：<span style="color: red; font-weight: bold;">{{selectedOrderCount}}</span></span>
			<span style="margin-left: 30px;">已选择箱数量：<span style="color: red; font-weight: bold;">{{selectedCartonCount}}</span></span>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleCancel">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
			<el-button type="primary" @click="handleSubmit">{{$t('commonInfo.dialogBtnConfirm')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'ChooseOrderCarton',
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		visible: {
			handler(newVal) {
				this.dialogVisible = newVal;
				if (newVal) {
					// 窗口打开时获取数据
					this.getOrderCartonData();
				} else {
					// 窗口关闭时清除勾选状态
					this.$nextTick(() => {
						if (this.$refs.tree) {
							this.$refs.tree.setCheckedKeys([]);
							this.selectedOrderCount = 0;
							this.selectedCartonCount = 0;
						}
					});
				}
			}
		},
		dialogVisible: {
			handler(newVal) {
				this.$emit('update:visible', newVal);
			}
		}
	},
	data() {
		return {
			dialogVisible: this.visible,
			orderTreeData: [],
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			selectedOrderCount: 0,
			selectedCartonCount: 0,
			searchText: '',
			allOrderData: [], // 存储所有订单数据，用于搜索
			globalCheckedKeys: [], // 全局存储已勾选的节点ID
			loading: false,
		};
	},
	mounted() {
		// 数据获取已移至watch中，窗口打开时自动获取
	},
	methods: {
		handleCancel() {
			// 关闭窗口重置变量
			this.searchText = '';
			this.globalCheckedKeys = [];
			this.orderTreeData = [];
			this.allOrderData = [];
			this.selectedOrderCount = 0;
			this.selectedCartonCount = 0;
			this.dialogVisible = false;
		},
		handleSubmit() {
			const checkedNodes = this.$refs.tree.getCheckedNodes(true);
			if(checkedNodes.length == 0){
				this.$message({
					message: '请选择订单或箱',
					type: 'warning'
				});
				return;
			}
			const selectedCartons = checkedNodes.filter(node => node.type === 'carton');
			const selectedAirCouOrders = checkedNodes.filter(node => node.type === 'order' && node.isAirCouOrder);
			let cartonData = [];
			selectedCartons.forEach(carton => {
				cartonData.push({
					// 订单号去箱号前14位
					orderNo: carton.orderNo || carton.label.substring(0, 14),	
					packageNo: carton.label,
					id: carton.id,
					transportType: carton.transportType,
					clientOperationType: carton.clientOperationType
				});
			});
			selectedAirCouOrders.forEach(order => {
				(order.cartonList || []).forEach(carton => {
					cartonData.push(this.buildCartonPayload(order, carton));
				});
			});
			this.$emit('submit', cartonData);
			this.dialogVisible = false;
		},
		handleCheckChange(data, checked, childrenChecked) { // data 节点数据 checked 是否勾选 childrenChecked 子节点是否被选中
			console.log(data, checked, childrenChecked);
			if (checked) {
				this.globalCheckedKeys.push(data.id);
				// 如果是订单，添加所有子节点ID到全局变量中
				if (data.type === 'order' && data.children && data.children.length > 0) {
					this.globalCheckedKeys = [...this.globalCheckedKeys, ...data.children.map(carton => carton.id)];
				}
			} else {
				this.globalCheckedKeys = this.globalCheckedKeys.filter(key => key !== data.id);
				// 如果是订单且没有点击子节点，则移除所有子节点ID
				if (data.type === 'order' && !childrenChecked && data.children && data.children.length > 0) {
					this.globalCheckedKeys = this.globalCheckedKeys.filter(key => !data.children.some(carton => carton.id === key));
				}
			}
			// 去重
			this.globalCheckedKeys = [...new Set(this.globalCheckedKeys)];	
			this.updateStats();
		},
		updateStats() {
			// 通过全局勾选数据统计
			const globalCheckedKeys = this.globalCheckedKeys;
			
			// 统计已选择的箱数量
			let cartonCount = 0;
			
			// 统计已选择的订单数量
			const selectedOrderIds = new Set();
			
			// 遍历所有订单数据
			this.allOrderData.forEach(order => {
				// 检查订单是否被直接勾选
				if (globalCheckedKeys.includes(order.id)) {
					selectedOrderIds.add(order.id);
					if (order.isAirCouOrder) {
						cartonCount += (order.cartonList || []).length;
					}
				}
				
				// 检查订单的子箱是否被勾选
				if (order.children && order.children.length > 0) {
					order.children.forEach(carton => {
						if (globalCheckedKeys.includes(carton.id)) {
							cartonCount++;
							// 如果箱被勾选，对应的订单也被视为已选择
							selectedOrderIds.add(order.id);
						}
					});
				}
			});
			
			this.selectedCartonCount = cartonCount;
			this.selectedOrderCount = selectedOrderIds.size;
		},
		getOrderCartonData() {
		   // 获取当前用户在库箱数据
		   let query = {
		       awbNos:[],// 箱号列表
			   tobOrderNos:[],// 订单号列表
			   locationName:''// 库位
		   }
		   this.loading = true;
			this.$http.post('/toborder/wms/carton/awbNoList',query).then(res => {
				if(res.code == 200){
					// 订单类型String 100空运 200海运 300 DOM 400 FBX 500 陆运					
					this.orderTreeData = []; 
					res.data.forEach(item => {
						const isAirCouOrder = item.transportType === '100' && item.clientOperationType == '1';
						let obj = {
							label: item.awbNo,
							type: 'order',
							orderType: this.returnOrderType(item.transportType),
							clientOperationTypeText: item.transportType === '100' ? this.returnClientOperationType(item.clientOperationType) : '',
							id: item.orderId + '-' + item.transportType, // 不同订单类型ID可能会重复
							children: [],
							cartonList: item.packageList || [],
							transportType: item.transportType,
							clientOperationType: item.clientOperationType,
							isAirCouOrder: isAirCouOrder,
						}
						if(!isAirCouOrder && item.packageList && item.packageList.length > 0){
							item.packageList.forEach(carton => {
								obj.children.push({
									label: carton.cartonAwbNo,
									id: carton.id,
									type: 'carton',
									orderNo: item.awbNo,
									transportType: item.transportType,
									clientOperationType: item.clientOperationType,
								});
							});
						}
						this.orderTreeData.push(obj);
					})
					this.allOrderData = this.orderTreeData; // 存储所有订单数据
				}
				this.loading = false;
			}).catch(error => {
				this.loading = false;
				this.$message.error(error.msg);
			})
		},
		handleSearch() {
			// 搜索功能
			if (!this.searchText) {
				// 清空搜索，显示所有订单
				this.orderTreeData = this.allOrderData;
				// 恢复全局勾选状态
				this.$nextTick(() => {
					if (this.$refs.tree) {
						this.$refs.tree.setCheckedKeys(this.globalCheckedKeys);
					}
				});
				return;
			}
			
			// 按回车换行分割搜索关键词
			const keywords = this.searchText.split('\n').filter(keyword => keyword.trim());
			
			if (keywords.length === 0) {
				return;
			}
			
			// 过滤匹配的订单
			const filteredOrders = this.allOrderData.filter(item => {
				// 检查订单号是否匹配
				const orderMatch = keywords.some(keyword => item.label.includes(keyword));
				
				// 检查箱号是否匹配
				const cartonMatch = item.children && item.children.some(carton => {
					return keywords.some(keyword => carton.label.includes(keyword));
				});
				
				return orderMatch || cartonMatch;
			});
			
			// 构建搜索结果
			this.orderTreeData = filteredOrders.map(item => {
				return {
					label: item.label,
					type: 'order',
					orderType: item.orderType,
					clientOperationTypeText: item.clientOperationTypeText,
					id: item.id,
					children: item.children || [],
					cartonList: item.cartonList || [],
					transportType: item.transportType,
					clientOperationType: item.clientOperationType,
					isAirCouOrder: item.isAirCouOrder,
				};
			});
			
			// 搜索完成后恢复全局勾选状态
			this.$nextTick(() => {
				if (this.$refs.tree) {
					this.$refs.tree.setCheckedKeys(this.globalCheckedKeys);
				}
			});
		},
		handleReset() {
			// 重置搜索条件
			this.searchText = '';
			this.orderTreeData = this.allOrderData;

			// 恢复全局勾选状态
			this.$nextTick(() => {
			  if (this.$refs.tree) {
				this.$refs.tree.setCheckedKeys(this.globalCheckedKeys);
			  }
			});	
		},
		handleSelectAll() {
			// 获取orderTreeData中的所有节点和子节点ID
			// 全选操作
			const allNodes = this.getAllNodes();
			this.$nextTick(() => {
			    this.$refs.tree.setCheckedNodes(allNodes);
			})
		},
		handleClearSelection() {
			// 清除勾选只清除当前页面的勾选状态，不包括全局勾选数据
			// 获取当前显示数据中的所有节点ID
			const currentKeys = this.getAllNodes().map(node => node.id);
			// 当前数据取消勾选状态
			this.$refs.tree.setCheckedKeys([]);
		    // 全局勾选去除当前显示数据中的所有节点ID
			this.globalCheckedKeys = this.globalCheckedKeys.filter(key => !currentKeys.includes(key));
			this.updateStats();
		},
		getAllNodes() {
			// 获取所有节点
			const getAllNodesRecursive = (nodes) => {
				let allNodes = [];
				nodes.forEach(node => {
					allNodes.push(node);
					if (node.children && node.children.length > 0) {
						allNodes = allNodes.concat(getAllNodesRecursive(node.children));
					}
				});
				return allNodes;
			};
			return getAllNodesRecursive(this.orderTreeData);
		},
		// 订单箱序号范围勾选功能
		handleRangeSelect(orderData) {
			if (orderData.isAirCouOrder) {
				this.$message.warning('空运COU订单不能挑箱派送，请直接勾选订单号');
				return;
			}
			// 箱序号范围选择
			if (!orderData.rangeInput) {
				return;
			}
			
			const input = orderData.rangeInput.trim();
			
			// 1. 校验输入格式
			// 只能输入纯数字、‘-’、‘，’这些信息
			if (!/^[\d,-]+$/.test(input)) {
				this.$message.warning('只能输入数字、-和,');
				return;
			}
			
			// 开头和结尾不能是‘-’字符
			if (input.startsWith('-') || input.endsWith('-')) {
				this.$message.warning('开头和结尾不能是-');
				return;
			}
			
			// 不能出现连续两个‘-’
			if (/--/.test(input)) {
				this.$message.warning('不能出现连续的-');
				return;
			}
			
			// 2. 解析输入，获取箱序号
			const parts = input.split(',');
			const boxNumbers = new Set();
			
			for (const part of parts) {
				const trimmedPart = part.trim();
				if (!trimmedPart) continue;
				
				if (trimmedPart.includes('-')) {
					// 范围勾选
					const rangeParts = trimmedPart.split('-');
					if (rangeParts.length !== 2) {
						this.$message.warning('范围格式不正确，如1-5');
						return;
					}
					
					const start = parseInt(rangeParts[0]);
					const end = parseInt(rangeParts[1]);
					
					if (isNaN(start) || isNaN(end)) {
						this.$message.warning('范围必须是数字');
						return;
					}
					
					if (start > end) {
						this.$message.warning('范围开始不能大于结束');
						return;
					}
					
					// 添加范围内的所有数字
					for (let i = start; i <= end; i++) {
						boxNumbers.add(i);
					}
				} else {
					// 单箱勾选
					const number = parseInt(trimmedPart);
					if (isNaN(number)) {
						this.$message.warning('序号必须是数字');
						return;
					}
					boxNumbers.add(number);
				}
			}
			
			// 3. 找到对应的订单数据
			const order = this.allOrderData.find(item => {
				return item.id === orderData.id;
			});
			
			if (order && order.children) {
				// 4. 过滤出符合条件的箱
				const selectedCartons = order.children.filter(carton => {
					// 从箱号后三位提取序号
					const cartonNumber = parseInt(carton.label.slice(-3));
					return boxNumbers.has(cartonNumber);
				});
				
				// 5. 处理勾选状态
				if (selectedCartons.length > 0) {
					const cartonIds = selectedCartons.map(carton => carton.id);
					
					// 保留其他订单的勾选状态，只更新当前订单的箱
					const otherCheckedKeys = this.globalCheckedKeys.filter(key => {
						// 检查key是否属于当前订单的箱
						const isCurrentOrderCarton = order.children.some(carton => carton.id === key);
						return !isCurrentOrderCarton;
					});
					
					const newCheckedKeys = [...otherCheckedKeys, ...cartonIds];
					this.$refs.tree.setCheckedKeys(newCheckedKeys);
					// 更新全局勾选数据
					this.globalCheckedKeys = [...this.globalCheckedKeys, ...new Set(newCheckedKeys)];
					// 去重
					this.globalCheckedKeys = [...new Set(this.globalCheckedKeys)];	
					this.updateStats();
					this.$message.success(`已选择${selectedCartons.length}个箱`);
				} else {
					this.$message.warning('该范围内没有找到箱');
				}
			}
		},
		// 返回订单类型名称	
		returnOrderType(type){
			let orderType = '';
			switch(type){
				case '100':
					orderType = 'AIR';
					break;
				case '200':
					orderType = 'SEA';
					break;
				case '300':
					orderType = 'DOM';
					break;
				case '400':
					orderType = 'FBX';
					break;
				case '500':
					orderType = 'LAND';
					break;
			}
			return orderType;
		},
		returnClientOperationType(type) {
			switch (String(type)) {
				case '1':
					return 'COU';
				case '2':
					return 'CARGO';
				default:
					return '';
			}
		},
		getNodeCartonCount(data) {
			if (!data || data.type !== 'order') {
				return 0;
			}
			if (data.isAirCouOrder) {
				return (data.cartonList || []).length;
			}
			return data.children && data.children.length > 0 ? data.children.length : 0;
		},
		buildCartonPayload(order, carton) {
			return {
				orderNo: order.label,
				packageNo: carton.cartonAwbNo,
				id: carton.id,
				transportType: order.transportType,
				clientOperationType: order.clientOperationType
			}
		}
	}
};
</script>

<style scoped>
.dialog-footer {
	text-align: center;
}

.stats-info {
	font-size: 14px;
}
.el-tree {
    border: 1px solid #efefef;
	padding: 5px;
	border-radius: 6px;
	height: 410px;
	overflow-y: auto;
	/* 滚动条样式 */
	&::-webkit-scrollbar {
		width: 4px;
		height: 8px;
	}
	&::-webkit-scrollbar-track {
		background-color: #f5f5f5;
	}
	&::-webkit-scrollbar-thumb {
		background-color: #ccc;
		border-radius: 4px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background-color: #999;
	}
}
/deep/ .el-tree-node{
	margin: 15px 0;
}
/deep/ .el-checkbox__input{
	vertical-align: baseline;
}
.tree-node-content{
  display: flex;
  align-items: center;
  vertical-align: middle;
  width: 100%;
  height: 32px;
}
.node-main-info{
  display: flex;
  align-items: center;
  min-width: 0;
  height: 32px;
}
.carton-node-info{
  display: flex;
  align-items: center;
  height: 32px;
}
.order-type-label{
  font-weight: bold;
  display: block;
  min-width: 32px;
  color: #6495ed;
  line-height: 18px;
}
.node-colon{
  display: block;
  margin: 0 6px 0 2px;
  color: #6495ed;
  font-weight: bold;
  text-align: center;
}
.node-label-text{
  display: block;
  line-height: 18px;
}
.client-operation-tag{
  display: block;
  width: 50px;
  margin: 0 4px;
  padding: 0 4px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}
.client-operation-cou{
  color: #d46b08;
  background: #fff7e6;
  border: 1px solid #ffd591;
}
.client-operation-cargo{
  color: #237804;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
}
.tree-node-content span{
  vertical-align: middle;
}
.tree-node-content /deep/ .cartonCount{
  display: block;
  line-height: 18px;
  color: hsl(136, 50%, 51%);
}
.range-input{
  width: 200px;
  float: right;
  margin-right: 10px;
}
</style>
